module.exports = __webpack_public_path__ + "img/logo.c691ffca.png";